import { createModel } from '@rematch/core';
import { IRootModel } from 'app/store';
import { IStatisticsState } from 'entities/Statistics/Statistics.models';
import { statisticsReducers } from 'entities/Statistics/Statistics.reducers';
import { statisticsEffects } from 'entities/Statistics/Statistics.effects';

export const statistics = createModel<IRootModel>()({
  state: {
    data: null,
    loading: false,
    watchUpdates: true,
  } as IStatisticsState,
  reducers: statisticsReducers,
  effects: statisticsEffects,
});
